import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FuseConfigService } from '@fuse/services/config.service';
import { MsgService } from 'app/main/components/msg/msg.service';

@Component({
  selector: 'app-goliza-welcome',
  templateUrl: './goliza-welcome.component.html',
  styleUrls: ['./goliza-welcome.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GolizaWelcomeComponent implements OnInit {

  public folioControl: FormControl = new FormControl(undefined, [Validators.required]);
  public isWaitingBusiness: Boolean = false;
  constructor(
    private _fuseConfigService: FuseConfigService,
    private _router: Router,
    private _msgService: MsgService
  ) { }

  ngOnInit(): void {
    this._fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        toolbar: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        sidepanel: {
          hidden: true
        }
      }
    };

  }

  find() {
    this.isWaitingBusiness = false;
    if (this.folioControl.value) {
      this.isWaitingBusiness = true;
    }
    else {
      this._msgService.error("Por favor ingresa un folio");
    }
  }


  launch(type: string) {
    if (this.folioControl.value) {
      this._router.navigateByUrl(`ticket/${this.folioControl.value}/${type}`);
    }
    else {
      this._msgService.error("Por favor ingresa un folio");
    }
  }

}
